export default {
    getAdvancedSearchState(state){
        return state.advancedSearchState
    },
    getAdvancedSearchDataFromStore(state){
        return state.advancedSearchDataFromStore;
    }
};